<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <div :id="model.$ID"></div>
  </dr-wrapper>
  <div v-else-if="isVisible" :class="evaluateClasses(classes)" :id="model.$ID"></div>
</template>
<script>
import baseMixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'

const RECAPTCHA_READY_EVENT = 'reCapthcaReady'
const RECAPTCHA_SCRIPT_ID = 'recaptcha'

export default {
  mixins: [baseMixin, inputMixin, widgetsWrapperMixin],
  data() {
    return {
      response: ''
    }
  },
  mounted() { 
    captchaScriptLoader({lang: this.$i18n.locale}).then(() => {
      this.renderCaptcha()
    })   
  },
  methods: {
    onCaptchaScriptLoad() {
      window['grecaptcha'].ready(() => {
        this.renderCaptcha()
      })
    },
    renderCaptcha() {
      
      window['grecaptcha'].render(this.model.$ID, {
        'sitekey': '6Lew-xUTAAAAAArSbDmSwM7U9JmwzrLBSGOsbjRO',
        'callback': (response) => {
          this.setDataSourceField(this.model.Value, !!response)
          this.response = response
        },
        'expired-callback': () => {
          this.setDataSourceField(this.model.Value, false)
        }
      })
    }
  }

}


function captchaScriptLoader({lang}) {
  
  return new Promise((resolve) => {

    if (document.getElementById(RECAPTCHA_SCRIPT_ID)) {
      if (window['grecaptcha']?.render) {
        resolve()
        return
      }
      window.addEventListener(RECAPTCHA_READY_EVENT, () => {
        resolve()
      })
      return
    }

    let script = document.createElement('script')
    script.id = RECAPTCHA_SCRIPT_ID
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=' + lang
    script.onload = function() {
      window['grecaptcha'].ready(() => {
        window.dispatchEvent(new CustomEvent(RECAPTCHA_READY_EVENT))
        resolve()
      })
    }
    document.head.append(script)
  })

 
}


</script>

